import React, { useEffect, useRef, useState } from 'react'
import { Grid, Typography, Button, Link, Card } from '@mui/material'
import colors from '../../../../../colors'
import ButtonGroup from '../../../../../general/ButtonGroup'
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from 'react-router-dom'
import { texts } from '../../../../../general/texts'
import { Dropdown } from 'primereact/dropdown';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import AddUserData from './AddUserData';
import { sendGeneralRequest } from '../../../../../../features/generalRequest';
import { selectGlobalDataState } from '../../../../../../features/global/globalDataSlice';
import useMediaQuery from '@material-ui/core/useMediaQuery';

export const Esim99 = (props) => {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const isSmallScreen = useMediaQuery('(max-width:600px)')
    const globalDataSliceState = useSelector(selectGlobalDataState)
    const [selectedOffer, setSelectedOffer] = useState('')
    const [userDetails, setUserDetails] = useState(false)
    const [countries, setCountries] = useState([])
    const [selectedCountry, setSelectedCountry] = useState('')
    const [regions, setRegions] = useState([])
    const [selectedRegion, setSelectedRegion] = useState('')
    const [displayedPackages, setDisplayedPackages] = useState([])
    const [trxId, setTrxId] = useState('')
    const [countryOperators, setCountryOperators] = useState([])
    const dropdownRef = useRef(null)

    const searchMethods = [
        { display: texts["button-country"], value: '1' },
        { display: texts["button-region"], value: '2' },
        { display: texts["button-global"], value: '3' }
    ]

    const [state, setState] = React.useState({
        utilityName: props?.utilityName,
        selectedSearchMethod: searchMethods[0]?.value
    })

    const handleFocus = () => {
        if (dropdownRef.current) {
            dropdownRef.current.focus()
        }
    }

    const getPackages = (category) => {
        dispatch(sendGeneralRequest({ request: { token: globalDataSliceState.token, trxId: trxId, category: category }, baseUrlKey: 'services', endpoint: 'Esim99/GetAllPackages99Esim' })).then(response => {
            if (response.payload.response.success) {
                setDisplayedPackages(response.payload.response.Packages)
            }
        })
    }

    useEffect(() => {
        dispatch(sendGeneralRequest({ request: { token: globalDataSliceState.token }, baseUrlKey: 'services', endpoint: 'Esim99/GetPackageCategories99Esim' })).then(response => {
            if (response.payload.response.success) {
                const regionalCategory = response.payload.response.Categories.find(
                    (category) => category.Name === "Regional"
                )
                if (regionalCategory && regionalCategory.Regional) {
                    setRegions(regionalCategory.Regional)
                    setSelectedRegion(regionalCategory.Regional[0])
                }
                setTrxId(response.payload.response.trxId)
                dispatch(sendGeneralRequest({ request: { token: globalDataSliceState.token, trxId: response.payload.response.trxId }, baseUrlKey: 'services', endpoint: 'Esim99/GetCountries99Esim' })).then(response => {
                    if (response.payload.response.success) {
                        setCountries(response.payload.response.Countries)
                        const albania = response.payload.response.Countries.find(
                            (country) => country.CountryName === "Albania"
                        );
                        setSelectedCountry(albania || response.payload.response.Countries[0]);
                        dispatch(sendGeneralRequest({ request: { token: globalDataSliceState.token, trxId: response.payload.response.trxId, category: albania?.CountryName || response.payload.response.Countries[0].CountryName }, baseUrlKey: 'services', endpoint: 'Esim99/GetAllPackages99Esim' })).then(response => {
                            if (response.payload.response.success) {
                                setDisplayedPackages(response.payload.response.Packages)
                            }
                        })
                    }
                })
            }
        })
    }, []);

    const selectedCountryTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <div>{state.selectedSearchMethod === '1' ? option.CountryName : option.Name}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const countryOptionTemplate = (option) => {
        return (
            <div className="flex align-items-center">
                <div>{state.selectedSearchMethod === '1' ? option.CountryName : option.Name}</div>
            </div>
        );
    };

    const chooseListOption = (value) => {
        if (state.selectedSearchMethod === '1') {
            setSelectedCountry(value)
            getPackages(value.CountryName)
        }
        else if (state.selectedSearchMethod === '2') {
            setSelectedRegion(value)
            getPackages(value.Name)
        }
        setSelectedOffer('')
    }

    const getSearchMethodValue = (value) => {
        setState({
            ...state,
            selectedSearchMethod: value
        })
        if (value === '1') {
            if (countries[0]) {
                getPackages(countries[0]?.CountryName)
                setSelectedOffer('')
            }
        }
        if (value === '2') {
            getPackages(regions[0]?.Name)
            setSelectedOffer('')
        }
        if (value === '3') {
            getPackages('Global')
            setSelectedOffer('')
        }
    }

    const handleButtonClick = () => {
        dispatch(sendGeneralRequest({ request: { token: globalDataSliceState.token, trxId: trxId, id: selectedOffer.PackageId }, baseUrlKey: 'services', endpoint: 'Esim99/GetOperators99Esim' })).then(response => {
            if (response.payload.response.success) {
                setCountryOperators(response.payload.response.CountryOperators)
                setUserDetails(true)
            }
        })
    }

    const selectedButtonStyle =
    {
        backgroundColor: colors.lightOrange,
        color: colors.orange,
        width: '150px',
        height: '40px',
        fontFamily: 'GerberaBold',
        textTransform: 'none',
        fontSize: '1rem',
        border: '2px solid' + colors.orange,
        borderRadius: '10px',
        '&:hover': {
            backgroundColor: colors.lightOrange
        },
        '@media (max-width: 899px)': { width: '130px', height: '40px' }
    }

    const defaultButtonStyle =
    {
        backgroundColor: colors.lightBlue,
        width: '150px',
        height: '40px',
        borderRadius: '10px',
        textTransform: 'none',
        fontFamily: 'GerberaLight',
        fontSize: '1rem',
        color: colors.darkBlue,
        '&:hover': {
            backgroundColor: colors.lightOrange
        },
        '@media (max-width: 899px)': { width: '130px', height: '40px' }
    }

    const useStyles = makeStyles({
        mainGrid: {
            padding: '5%',
            paddingTop: '3%'
        },
        utilityName: {
            color: colors.orange,
            fontSize: '1.5rem',
            fontFamily: 'GerberaBold',
            paddingTop: '3%',
            paddingLeft: '2%'
        },
        headerBox: {
            backgroundColor: colors.cyan,
            borderRadius: '100%',
            width: '70px',
            height: '70px'
        },
        fieldTitle: {
            color: colors.darkBlue,
            fontSize: '1.2rem',
            fontFamily: 'GerberaBold',
            textAlign: 'left'
        },
        subtitle: {
            color: colors.darkBlue,
            fontSize: '1rem',
            fontFamily: 'GerberaLight',
            marginTop: 20,
            textAlign: 'left'
        },
        button: {
            width: '100%',
            color: colors.white,
            fontSize: '1rem',
            textTransform: 'none',
            background: colors.gradientOrange,
            fontFamily: 'GerberaBold'
        },
        buttonGrid: {
            marginTop: 10,
            paddingBottom: 5
        },
        image: {
            width: '50%',
        },
        textField: {
            width: '100%'
        }
    })

    const classes = useStyles()


    return (
        <Grid container item md={12} xs={12} justifyContent={"center"} pt={"2%"}>
            <Card
                sx={{
                    borderRadius: "20px",
                    boxShadow: "0 0 15px 5px #E5E7EA",
                    padding: "20px",
                    background: colors.white,
                    display: 'flex',
                    flexDirection: 'column',
                    width: "650px",
                    minHeight: "65vh",
                    "@media (max-width: 899px)": { width: "80%" },
                }}
            >
                {
                    !userDetails ? (
                        <Grid container item className={classes.mainGrid} rowSpacing={2}>
                            <Grid container item md={2} xs={2} mt={2} ><Link component={'button'} onClick={() => { navigate(-1) }}><ArrowBackIosNewIcon color='warning' /></Link></Grid>
                            <Grid container item md={12} xs={12}>
                                <Grid container direction="row" justifyContent="center" alignItems="center" className={classes.headerBox} ><img src={props?.utilityInfo?.Images?.filter(image => image.color === 1 && image.size === 1)[0]?.imagePath} className={classes.image} /></Grid>
                                <Typography className={classes.utilityName}>{props?.utilityInfo?.PublicName}</Typography>
                            </Grid>
                            <Grid container item md={12} xs={12} >
                                <Typography className={classes.fieldTitle}>{texts["prompt-choose-payment-plan"]}</Typography>
                            </Grid>
                            <Grid container item md={12} xs={12} justifyContent='flex-start' columnSpacing={5} rowSpacing={3} >
                                <ButtonGroup defaultButtonStyle={defaultButtonStyle} selectedButtonStyle={selectedButtonStyle} state={searchMethods} sendValue={getSearchMethodValue} />
                            </Grid>
                            {state.selectedSearchMethod !== '3' && (
                                <>
                                    <Typography className={classes.subtitle}>{state.selectedSearchMethod === '1' ? texts['prompt-choose-country'] : texts['prompt-choose-region']}</Typography>
                                    <Dropdown ref={dropdownRef} value={state.selectedSearchMethod === '1' ? selectedCountry : selectedRegion} onFocus={handleFocus} onChange={(e) => chooseListOption(e.value)} options={state.selectedSearchMethod === '1' ? countries : regions} optionLabel={state.selectedSearchMethod === '1' ? "CountryName" : "Name"} placeholder="Selekto"
                                        filter valueTemplate={selectedCountryTemplate} itemTemplate={countryOptionTemplate} className="w-full md:w-14rem" style={{
                                            borderColor: 'rgb(235, 173, 135)',
                                            width: '535px',
                                            marginTop: 8
                                        }} />
                                </>
                            )}
                            {state.selectedSearchMethod === '3' && (
                                <Grid container item md={12} xs={12} >
                                    <Typography className={classes.fieldTitle}>Plani Global</Typography>
                                </Grid>
                            )}
                            <Typography className={classes.subtitle}>{texts['prompt-choose-packet']}</Typography>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px 10px', marginTop: 8 }}>
                                {displayedPackages.length > 0 ? (
                                    displayedPackages.map((item, index) => (
                                        <div key={index}
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'space-between',
                                                border: selectedOffer === item ? '1px solid rgb(235, 173, 135)' : '1px solid lightgray',
                                                borderRadius: '8px',
                                                padding: '15px 8px',
                                                width: '265px',
                                                cursor: 'pointer',
                                            }}
                                            onClick={() => setSelectedOffer(item)}
                                        >
                                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                                {selectedOffer === item ? (
                                                    <RadioButtonCheckedIcon color="warning" style={{ fontSize: '18px', marginTop: 6 }} />
                                                ) : (
                                                    <RadioButtonUncheckedIcon color="warning" style={{ fontSize: '18px', marginTop: 6 }} />
                                                )}
                                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                    <Typography
                                                        style={{
                                                            marginLeft: 10,
                                                            color: colors.darkBlue,
                                                            fontFamily: 'GerberaLight',
                                                            fontSize: '12px',
                                                            textAlign: 'left'
                                                        }}
                                                    >
                                                        {item.DisplayName}
                                                    </Typography>
                                                    <Typography
                                                        style={{
                                                            marginLeft: 10,
                                                            color: colors.orange,
                                                            fontFamily: 'GerberaMedium',
                                                            fontSize: '12px',
                                                        }}
                                                    >
                                                        {item.ConvertedData + ' - ' + item.Validity + ' ' + texts['days']}
                                                    </Typography>
                                                </div>
                                            </div>
                                            <Typography
                                                style={{
                                                    color: colors.darkBlue,
                                                    fontFamily: 'GerberaMedium',
                                                    fontSize: '16px',
                                                    marginTop: 6
                                                }}
                                            >
                                                {item.SellPrice} €
                                            </Typography>
                                        </div>
                                    ))) : (
                                    <Typography
                                        style={{
                                            color: colors.gray,
                                            fontFamily: 'GerberaLight',
                                            fontSize: '14px',
                                            width: '100%',
                                            marginTop: 60,
                                            marginBottom: 20,
                                            marginLeft: isSmallScreen ? 30 : 60
                                        }}
                                    >
                                        {texts['message-no-offers-disponible']}
                                    </Typography>
                                )}
                            </div>
                            <Grid item md={12} xs={12} className={classes.buttonGrid}  >
                                <Button onClick={handleButtonClick} disabled={!selectedOffer} className={classes.button}>{texts["button-continue"]}</Button>
                            </Grid>
                        </Grid>
                    ) : (
                        <AddUserData operators={countryOperators} state={state.selectedSearchMethod} trxId={trxId} package={selectedOffer} />
                    )
                }
            </Card>
        </Grid>

    )
}
export default Esim99;
